import _ from 'lodash';
import {CHECKOUT_TYPE_PPV} from './review';
import { createSelector } from 'reselect';

export const currentReviewContentState = state => state.review.content;

export const reviewSelector = createSelector(
  currentReviewContentState,
  content => _.get(content, 'review', [])
);

export const reviewFlowTypeSelector = createSelector(
  reviewSelector,
  review => _.get(review, 'flowType')
);

export const reviewSummarySelector = createSelector(
  reviewSelector,
  reviewFlowTypeSelector,
  (review, flowType) => {
    const summary = _.get(review, 'reviewSummary', {});

    return flowType === CHECKOUT_TYPE_PPV ? { ...summary, newMonthlyTotalCharges: null } : summary;
  }
);

export const contractsSelector = createSelector(
  reviewSelector,
  review => _.get(review, 'contracts', [])
);

export const contractIdsSelector = createSelector(
  contractsSelector,
  contracts => _.map(contracts, contract => contract.contractId)
);

export const cartSelector = createSelector(
  currentReviewContentState,
  content => _.get(content, 'cart', {})
);

export const monthlyChargesSectionSelector = createSelector(
  reviewSelector,
  review => _.get(review, 'reviewChargesSection.monthlyChargesSection', [])
);

export const monthlyReviewItemsSelector = createSelector(
  monthlyChargesSectionSelector,
  review => _.get(review, 'reviewItems', [])
);

export const monthlyReviewSubItemsSelector = createSelector(
  monthlyChargesSectionSelector,
  review => _.get(review, 'reviewSubItems', [])
);

export const monthlyChargesSelector = createSelector(
  monthlyReviewItemsSelector,
  monthlyReviewSubItemsSelector,
  (monthlyItems, monthlySubItems) => _.merge({}, monthlyItems, monthlySubItems)
);

export const oneTimeChargesSectionSelector = createSelector(
  reviewSelector,
  review => _.get(review, 'reviewChargesSection.oneTimeChargesSection', [])
);

export const oneTimeChargesSelector = createSelector(
  oneTimeChargesSectionSelector,
  review => _.get(review, 'reviewItems', [])
);

export const removedChargesSectionSelector = createSelector(
  reviewSelector,
  review => _.get(review, 'reviewChargesSection.removedChargesSection', [])
);

export const removedReviewItemsSelector = createSelector(
  removedChargesSectionSelector,
  review => _.get(review, 'reviewItems', [])
);

export const removedReviewSubItemsSelector = createSelector(
  removedChargesSectionSelector,
  review => _.get(review, 'reviewSubItems', [])
);

export const removedChargesSelector = createSelector(
  removedReviewItemsSelector,
  removedReviewSubItemsSelector,
  (monthlyItems, monthlySubItems) => _.merge({}, monthlyItems, monthlySubItems)
);

export const allChargesSelector = createSelector(
  monthlyReviewItemsSelector,
  monthlyReviewSubItemsSelector,
  oneTimeChargesSelector,
  removedReviewItemsSelector,
  removedReviewSubItemsSelector,
  (monthlyItems, monthlySubItems, oneTimeItems, removedItems, removedSubItems) => {
    return _.merge({}, monthlyItems, monthlySubItems, oneTimeItems, removedItems, removedSubItems);
  }
);

export const showShippingAddressSelector = createSelector(
  monthlyReviewSubItemsSelector,
  subItems => !_.isEmpty(subItems.equipment)
);



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/review/reviewSelectors.js
 **/